import styled from 'styled-components';
import { ContainerSection } from '@/main/components/shared/styles';

export const Container = styled(ContainerSection)`
  margin: 2rem 0;
`;

export const BodySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(2, 1fr);
  gap: 0.4rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

